/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { Close, Save } from '@material-ui/icons';

import useStyles from './styles';

interface IEditWeeklyTitlesGoalModalProps {
  open: boolean;
  editingData?: IWeeklyTitlesGoalBySite;
  handleClose: () => void;
  onSaveWeekTitlesGoal: (
    sitePreferencesId: string,
    articles: number,
    news: number,
    translator: number,
  ) => void;
}

const EditWeeklyTitlesGoalModal: React.FC<IEditWeeklyTitlesGoalModalProps> = ({
  open,
  editingData,
  handleClose,
  onSaveWeekTitlesGoal,
}) => {
  const classes = useStyles();

  const [articles, setArticles] = useState('0');
  const [news, setNews] = useState('0');
  const [translator, setTranslator] = useState('0');
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    if (open) {
      setArticles(String(editingData?.article) || '0');
      setNews(String(editingData?.news) || '0');
      setTranslator(String(editingData?.translator) || '0');
      setErrors({});
    }
  }, [open]);

  const onSave = () => {
    if (hasValidationError()) return;

    onSaveWeekTitlesGoal(
      editingData!.sitePreferencesId,
      parseInt(articles, 10),
      parseInt(news, 10),
      parseInt(translator, 10),
    );
  };

  const hasValidationError = () => {
    const errors = {
      ...((parseInt(articles, 10) < 0 || articles.trim() === '') && {
        articles: true,
      }),
      ...((parseInt(news, 10) < 0 || news.trim() === '') && { news: true }),
      ...((parseInt(translator, 10) < 0 || translator.trim() === '') && {
        translator: true,
      }),
    };

    setErrors(errors);

    if (Object.values(errors).length > 0) {
      return true;
    }

    return false;
  };

  return (
    <Modal open={open} className={classes.modal} onClose={handleClose}>
      <Fade in={open}>
        <Box className={classes.modalPaper}>
          <Box className={classes.modalHeader}>
            <Box className={classes.modalHeaderSide} />
            <Box className={classes.modalHeaderCenter}>
              <Typography align="center" variant="h4">
                Edit <b>{editingData?.domain}</b> Week Titles Goal
              </Typography>
            </Box>
            <Box
              className={clsx(
                classes.modalHeaderSide,
                classes.modalCloseContainer,
              )}
            >
              <Box className={classes.modalClose}>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Box className={classes.modalInputs}>
            <TextField
              label="Articles"
              type="number"
              error={errors.articles}
              variant="outlined"
              size="small"
              InputProps={{
                inputProps: {
                  min: 0,
                },
              }}
              value={articles}
              onChange={(e) => setArticles(e.target.value)}
            />
            <TextField
              label="News"
              type="number"
              error={errors.news}
              variant="outlined"
              className={classes.textFieldBorders}
              size="small"
              InputProps={{
                inputProps: {
                  min: 0,
                },
              }}
              value={news}
              onChange={(e) => setNews(e.target.value)}
            />
            <TextField
              label="Translator"
              type="number"
              error={errors.translator}
              variant="outlined"
              size="small"
              InputProps={{
                inputProps: {
                  min: 0,
                },
              }}
              value={translator}
              onChange={(e) => setTranslator(e.target.value)}
            />
          </Box>

          <Button
            variant="contained"
            color="primary"
            className={classes.saveButton}
            onClick={onSave}
            startIcon={<Save />}
          >
            Save
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditWeeklyTitlesGoalModal;
